// Optional end date/time formatting helpers for RoadRnr events.
// Structured fields on an event: start_date "YYYY-MM-DD", start_time "HH:MM",
// end_date, end_time (all optional except start_date). Falls back gracefully to
// the legacy display `event.date` string when structured fields are absent.

const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];
const MONTHS_SHORT = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

function parse(d) {
  if (!d) return null;
  const [y, m, day] = String(d).split("-").map(Number);
  if (!y || !m || !day) return null;
  return { y, m: m - 1, d: day };
}

const sameDay = (a, b) => a && b && a.y === b.y && a.m === b.m && a.d === b.d;

// Detail page display. Returns { dateLabel, timeLabel }.
// e.g. "25 June – 28 June 2026" / "09:00 – 18:00"  or  "8 August 2026" / "Starts 09:00"
export function formatDetailDate(event) {
  const s = parse(event.start_date);
  if (!s) return { dateLabel: event.date || "", timeLabel: "" };

  const e = parse(event.end_date);
  let dateLabel;
  if (e && !sameDay(s, e)) {
    dateLabel =
      s.y === e.y
        ? `${s.d} ${MONTHS[s.m]} – ${e.d} ${MONTHS[e.m]} ${e.y}`
        : `${s.d} ${MONTHS[s.m]} ${s.y} – ${e.d} ${MONTHS[e.m]} ${e.y}`;
  } else {
    dateLabel = `${s.d} ${MONTHS[s.m]} ${s.y}`;
  }

  let timeLabel = "";
  if (event.start_time && event.end_time) {
    timeLabel = `${event.start_time} – ${event.end_time}`;
  } else if (event.start_time) {
    timeLabel = `Starts ${event.start_time}`;
  }

  return { dateLabel, timeLabel };
}

// Compact card display. Returns a short range when an end date exists, otherwise
// the legacy `event.date` string (preserves existing look for single-day events).
export function formatCardDate(event) {
  const s = parse(event.start_date);
  const e = parse(event.end_date);

  if (s && e && !sameDay(s, e)) {
    if (s.y === e.y && s.m === e.m) return `${s.d}–${e.d} ${MONTHS_SHORT[s.m]} ${s.y}`;
    if (s.y === e.y) return `${s.d} ${MONTHS_SHORT[s.m]} – ${e.d} ${MONTHS_SHORT[e.m]}`;
    return `${s.d} ${MONTHS_SHORT[s.m]} ${s.y} – ${e.d} ${MONTHS_SHORT[e.m]} ${e.y}`;
  }

  if (event.date) return event.date;
  return s ? `${s.d} ${MONTHS_SHORT[s.m]} ${s.y}` : "";
}
